import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Layout from '../Sections/Layout';

import { sleepy, videoResolutionConstraints } from '../../utils/webcam/webrtc';
import AmeraWebrtcClient from '../../utils/webcam/client';
import usePrevious from '../../hooks/usePrevious';
import {
  setLocalStream,
  setLocalDevices,
  setLocalSelected,
  setHasEchoCancellation,
  setLocalVideoEnabled,
  setLocalAudioEnabled,
  setClearCall,
  setCallEndedByRemote,
  getMemberInfo,
} from '../../redux/actions/one2onevcall';

import FirstScreenMode from './FirstScreenMode';
import SecondScreenMode from './SecondScreenMode';
import ThirdScreenMode from './ThirdScreenMode';
import { sendNotification, clearReplyMessage } from '../../redux/actions/event';

let thisIsTricky = { name: 'hello son!' };

export const getTrick = () => {
  return thisIsTricky;
};

export const setTrick = (value) => {
  thisIsTricky = value;
  // return thisIsTricky;
};

let awc = null,
  worker;

const One2OneVCall = (props) => {
  const [remoteVideoEnabled, setRemoteVideoEnabled] = useState(true);
  const [remoteAudioEnabled, setRemoteAudioEnabled] = useState(true);
  const [audioOutput, setAudioOutput] = useState(undefined);
  const [remoteSelected, setRemoteSelected] = useState(null);
  const [showCallStatusModal, setShowCallStatusModal] = useState(false);
  const [ameraWebrtcClient, setAmeraWebrtcClient] = useState(null);
  const [viewMode, setViewMode] = React.useState('second_mode');
  const [connectionType, setConnectionType] = useState(null);

  let localVideoRef = useRef(null);
  let remoteVideoRef = useRef(null);
  const previousViewMode = usePrevious(viewMode);
  const history = useHistory();

  const handleViewMode = (event, newAlignment) => {
    setViewMode(newAlignment);
  };

  const {
    memberInfo,
    localStream,
    remoteStream,
    localDevices,
    remoteDevices,
    // ameraWebrtcClient,
    localSelected,
    localAudioEnabled,
    localVideoEnabled,
    hasEchoCancellation,
    encryptEnabled,
    remoteEncryptEnabled,
    binaryString,
    replyMessage,
    login,
    partnerInfo,
    callReply,
    member_id,
    callStarted,
    callEndedByRemote,
    dispatch,
  } = props;

  let previousSelect = usePrevious(localSelected);
  let previousEncryptEnabled = usePrevious(encryptEnabled);
  let previousRemoteEncryptEnabled = usePrevious(remoteEncryptEnabled);
  const previousHasEchoCancellation = usePrevious(hasEchoCancellation);

  useEffect(() => {
    /**
     * check if devices are available and browser supports Insertable Streams.
     * get devices, stream, also send local stream
     */

    const firstTime = async (user) => {
      worker = new Worker(`${process.env.PUBLIC_URL}/worker.js`);
      await start();
      awc = new AmeraWebrtcClient('contact', worker);
      awc.connectWebsocket(user);
      setAmeraWebrtcClient(awc);
    };

    if (
      memberInfo &&
      memberInfo.email &&
      memberInfo.member_id &&
      memberInfo.first_name &&
      memberInfo.last_name
    )
      firstTime({
        username: memberInfo.email,
        member_id: memberInfo.member_id,
        first_name: memberInfo.first_name,
        last_name: memberInfo.last_name,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberInfo.email, memberInfo.first_name, memberInfo.last_name]);

  useEffect(() => {
    if (ameraWebrtcClient && ameraWebrtcClient.connection && localStream)
      getTrackChange();
    getConnectionType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ameraWebrtcClient, localStream]);

  const getStream = async (constraints) => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      await dispatch(setLocalStream(stream));
      await dispatch(
        setLocalSelected({
          audioinput: stream.getAudioTracks()[0].getSettings().deviceId,
          videoinput: stream.getVideoTracks()[0].getSettings().deviceId,
        })
      );
    } catch (error) {
      // handleMediaError(error);
    }
  };

  const reload = async () => {
    muteAudio(false);
    muteVideo(false);
    // if (localVideoRef.current) localVideoRef.current.srcObject = null;
    if (remoteVideoRef.current && remoteStream)
      remoteVideoRef.current.srcObject = null;
    await sleepy(2000);
    muteAudio(localAudioEnabled);
    muteVideo(localVideoEnabled);
    await start();
    if (remoteVideoRef.current && remoteStream)
      remoteVideoRef.current.srcObject = remoteStream;
  };

  useEffect(() => {
    if (
      previousEncryptEnabled === undefined &&
      previousRemoteEncryptEnabled === undefined
    )
      return;
    reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [encryptEnabled, remoteEncryptEnabled]);

  useEffect(() => {
    if (viewMode && previousViewMode !== undefined) reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewMode]);

  useEffect(() => {
    if (localSelected && localSelected.audioinput && localSelected.videoinput) {
      if (
        !previousSelect ||
        previousSelect.audioinput !== localSelected.audioinput ||
        previousSelect.videoinput !== localSelected.videoinput ||
        previousSelect.videores !== localSelected.videores
      )
        // getStream(constraints);
        reload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localSelected]);

  useEffect(() => {
    if (previousHasEchoCancellation !== undefined) {
      // getStream(constraints);
      reload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasEchoCancellation]);

  useEffect(() => {
    if (
      !ameraWebrtcClient ||
      !localSelected ||
      !localDevices ||
      !ameraWebrtcClient.connect
    )
      return;
    const myDevices = localDevices.map((device) => ({
      kind: device.kind,
      label: device.label,
      deviceId: device.deviceId,
      selected: localSelected[device.kind] === device.deviceId,
    }));

    const myoptions = {
      type: 'devices',
      devices: myDevices,
    };
    ameraWebrtcClient.sendUserMessage(myoptions);
  }, [ameraWebrtcClient, localSelected, localDevices]);

  useEffect(() => {
    if (login && replyMessage) {
      sendNotification(replyMessage);
      dispatch(clearReplyMessage());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [login, replyMessage]);

  const start = async () => {
    let constraints = {
      audio: {
        deviceId:
          localSelected && localSelected.audioinput
            ? localSelected.audioinput
            : undefined,
      },
      echoCancellation: {
        exact: hasEchoCancellation,
      },
    };
    // start with normal device selected, add in resolution that might be requested
    // the request will be an object with potentially multiple key values, like
    let videoConstraints = {
      deviceId:
        localSelected && localSelected.videoinput
          ? localSelected.videoinput
          : undefined,
    };
    if (localSelected && localSelected.videores) {
      videoConstraints = {
        ...videoConstraints,
        ...videoResolutionConstraints[localSelected.videores],
      };
    }

    constraints.video = videoConstraints;

    await getStream(constraints);
    await getDevices();
    navigator.mediaDevices.addEventListener('devicechange', async (event) => {
      getDevices();
    });
  };

  const getDevices = () => {
    navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => {
        dispatch(setLocalDevices(devices));
      })
      .catch((error) => {
        console.log('error error', error);
      });
  };

  const getTrackChange = () => {
    if (!localStream || !ameraWebrtcClient) return;
    // https://stackoverflow.com/questions/57235211/webrtcs-replacetrack-suddenly-not-working-in-firefox
    if (ameraWebrtcClient.connection) {
      ameraWebrtcClient.connection.getSenders().forEach((sender) => {
        sender.replaceTrack(
          localStream.getTracks().find(function (track) {
            return sender.track.kind ? track.kind === sender.track.kind : false;
          })
        );
      });
    }
  };

  const getConnectionType = () => {
    if (!localStream || !ameraWebrtcClient) return;

    if (
      ameraWebrtcClient.connection &&
      ameraWebrtcClient.connection.connectionType
    ) {
      setConnectionType(ameraWebrtcClient.connection.connectionType);
    }
  };

  // const handleMediaError = (error) => {
  //   console.log(`start(): : ${error.name}, ${error.message} ${error.stack}`);
  //   // restartOnError();
  //   alert(`getUserMedia ${error.name}:\n${error.message}`);
  // };

  // const restartOnError = async () => {
  //   console.log('restartOnError');
  //   await sleepy(250);
  //   start();
  // };

  const clearAll = () => {
    if (awc) {
      awc.handleClose();
      if (awc.ws) {
        awc.ws.close();
        awc.ws = null;
      }
    }

    dispatch(setClearCall());
  };

  useEffect(() => {
    window.addEventListener('beforeunload', clearAll);
    return () => {
      window.removeEventListener('beforeunload', clearAll);
      clearAll();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (localStream && localVideoRef.current) {
      localVideoRef.current.srcObject = localStream;
      // if (localStream) localVideoRef.current.setAttribute('controls', true);
      muteAudio(localAudioEnabled);
      muteVideo(localVideoEnabled);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStream, localVideoRef.current]);

  useEffect(() => {
    if (remoteVideoRef.current) {
      remoteVideoRef.current.srcObject = remoteStream;
      // if (remoteStream) remoteVideoRef.current.setAttribute('controls', true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remoteStream, remoteVideoRef.current]);

  const handleLocalVideo = () => {
    dispatch(setLocalVideoEnabled(!localVideoEnabled));
  };

  const handleLocalAudio = () => {
    dispatch(setLocalAudioEnabled(!localAudioEnabled));
  };

  useEffect(() => {
    muteAudio(localAudioEnabled);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localAudioEnabled]);

  useEffect(() => {
    muteVideo(localVideoEnabled);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localVideoEnabled]);

  const muteAudio = (onoff = null) => {
    if (localStream)
      localStream
        .getAudioTracks()
        .forEach((t) => (t.enabled = onoff != null ? onoff : !t.enabled));
  };
  const muteVideo = (onoff = null) => {
    if (localStream)
      localStream
        .getVideoTracks()
        .forEach((t) => (t.enabled = onoff != null ? onoff : !t.enabled));
  };

  const handleLocalAudioChange = (event) => {
    dispatch(
      setLocalSelected({ ...localSelected, audioinput: event.target.value })
    );
  };

  const handleLocalVideoChange = (event) => {
    dispatch(
      setLocalSelected({ ...localSelected, videoinput: event.target.value })
    );
  };

  const handleEchoCancellation = () => {
    dispatch(setHasEchoCancellation(!hasEchoCancellation));
  };
  const changeAudioDestination = async (event) => {
    event.persist();
    const result = await attachSinkId(
      localVideoRef.current,
      event.target.value
    );
    if (result) setAudioOutput(event.target.value);
    else setAudioOutput('default');
  };

  /** Attach audio output device to video element using device/sink ID. event handler for change audio dest
   *
   * @param {*} element
   * @param {*} sinkId
   */
  const attachSinkId = (element, sinkId) => {
    return new Promise((resolve, reject) => {
      if (typeof element.sinkId !== 'undefined') {
        element
          .setSinkId(sinkId)
          .then(() => {
            console.log(`Success, audio output device attached: ${sinkId}`);
            resolve(true);
          })
          .catch((error) => {
            let errorMessage = error;
            if (error.name === 'SecurityError') {
              errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`;
            }
            console.error(errorMessage);
            // Jump back to first output device in the list as it's the default.
            resolve(false);
          });
      } else {
        console.warn('Browser does not support output device selection.');
        resolve(false);
      }
    });
  };

  const handleRemoteVideo = () => {
    if (!ameraWebrtcClient) return;
    const mytoggle = {
      kind: 'videoinput',
      enabled: !remoteVideoEnabled,
    };

    ameraWebrtcClient.sendUserMessage({
      type: 'toggletrack',
      toggle: mytoggle,
    });
    setRemoteVideoEnabled((prev) => !prev);
  };

  const handleRemoteAudio = () => {
    if (!ameraWebrtcClient) return;
    const mytoggle = {
      kind: 'audioinput',
      enabled: !remoteAudioEnabled,
    };

    ameraWebrtcClient.sendUserMessage({
      type: 'toggletrack',
      toggle: mytoggle,
    });
    setRemoteAudioEnabled((prev) => !prev);
  };

  const handleRemoteAudioChange = (event) => {
    event.persist();
    setRemoteSelected((prev) =>
      prev
        ? { audioinput: event.target.value }
        : { ...prev, audioinput: event.target.value }
    );
  };

  const handleRemoteVideoChange = (event) => {
    event.persist();
    setRemoteSelected((prev) =>
      prev
        ? { videoinput: event.target.value }
        : { ...prev, videoinput: event.target.value }
    );
  };

  const handleRemoteResolutionChange = (event) => {
    event.persist();
    setRemoteSelected((prev) =>
      prev
        ? { videores: event.target.value }
        : { ...prev, videores: event.target.value }
    );
  };

  useEffect(() => {
    if (remoteSelected) {
      if (ameraWebrtcClient)
        ameraWebrtcClient.sendUserMessage({
          type: 'changedevices',
          select: {
            constraints: { video: true, audio: true },
            devices: remoteSelected,
          },
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remoteSelected]);

  const handleCloseCall = () => {
    if (ameraWebrtcClient) ameraWebrtcClient.handleClose();
    history.goBack();
  };
  const handleCloseCallFromModal = () => {
    if (showCallStatusModal) {
      dispatch({ type: 'CALL_REPLY', payload: null });
      setShowCallStatusModal(false);
    } else {
      dispatch(setCallEndedByRemote(false));
    }
    history.goBack();
  };

  const makeCall = () => {
    if (ameraWebrtcClient) {
      dispatch({ type: 'CALL_REPLY', payload: null });
      ameraWebrtcClient.call(partnerInfo.email);
    }
  };

  useEffect(() => {
    if (callReply) {
      if (partnerInfo && partnerInfo.member_id === callReply.callee_id) {
        if (callReply.reply_type === 'decline') {
          setShowCallStatusModal(true);
        } else {
          makeCall();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callReply]);

  useEffect(() => {
    if (member_id) {
      dispatch(getMemberInfo(member_id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [member_id]);

  const childProps = {
    localAudioEnabled,
    localVideoEnabled,
    localSelected,
    localDevices,
    audioOutput,
    hasEchoCancellation,
    binaryString,
    handleLocalVideo,
    handleLocalAudio,
    handleEchoCancellation,
    handleLocalAudioChange,
    changeAudioDestination,
    handleLocalVideoChange,
    handleRemoteVideoChange,
    handleRemoteAudioChange,
    handleRemoteVideo,
    handleRemoteAudio,
    localVideoRef,
    remoteVideoRef,
    remoteDevices,
    handleRemoteResolutionChange,
    handleViewMode,
    viewMode,
    showCallStatusModal,
    setShowCallStatusModal,
    handleCloseCall,
    makeCall,
    handleCloseCallFromModal,
    localStream,
    remoteStream,
    partnerInfo,
    ameraWebrtcClient,
    callStarted,
    connectionType,
    callEndedByRemote,
  };

  return (
    <Layout {...props}>
      {viewMode === 'first_mode' ? (
        <FirstScreenMode {...childProps} />
      ) : viewMode === 'second_mode' ? (
        <SecondScreenMode {...childProps} />
      ) : (
        <ThirdScreenMode {...childProps} />
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  partner: state.one2onevcall.partner,
  localStream: state.one2onevcall.localStream,
  remoteStream: state.one2onevcall.remoteStream,
  localDevices: state.one2onevcall.localDevices,
  remoteDevices: state.one2onevcall.remoteDevices,
  // ameraWebrtcClient: state.one2onevcall.ameraWebrtcClient,
  localSelected: state.one2onevcall.localSelected,
  hasEchoCancellation: state.one2onevcall.hasEchoCancellation,
  localAudioEnabled: state.one2onevcall.localAudioEnabled,
  localVideoEnabled: state.one2onevcall.localVideoEnabled,
  encryptEnabled: state.one2onevcall.encryptEnabled,
  remoteEncryptEnabled: state.one2onevcall.remoteEncryptEnabled,
  binaryString: state.one2onevcall.binaryString,
  login: state.one2onevcall.login,
  partnerInfo: state.one2onevcall.partnerInfo,
  replyMessage: state.event.replyMessage,
  callReply: state.event.callReply,
  member_id: state.one2onevcall.member_id,
  memberInfo: state.member.memberInfo,
  callEndedByRemote: state.one2onevcall.callEndedByRemote,
  callStarted: state.one2onevcall.callStarted,
});

export default connect(mapStateToProps)(One2OneVCall);
